import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import useThemeRender from "../../../../theme/useThemeRender";
import axios from "../../../../API/API";
import { BASE_URL } from "../../../../constant/apiUrl";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setAlert, setSpotlight } from "../../../../slices/spotlightSlice";
import { useNavigate } from "react-router-dom";
import { setPage, setReset } from "../../../../slices/adminPageSlice";
import PropTypes from "prop-types";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
export default function AlertBox({
  deleteSlotId,
  setFetch,
  token,
  action,
  selected,
  content,
  fetch,
}) {
  const { alertMessage, spotlight } = useSelector((store) => store.spotlight);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setAlert(false));
  };

  const handleRemove = async () => {
    try {
      if (action === "Remove") {
        const updated = spotlight.filter(
          (item) => item.slotNumber !== deleteSlotId
        ); // Remove the item
        dispatch(setSpotlight(updated));
        const payload = updated.map((item, index) => ({
          contentId: item.contentId,
          slotNumber: index + 1,
        })); // Reassign slotNumbers

        const response = await axios.put(
          `${BASE_URL}/spotlights/update`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response?.status === 200) {
          setFetch(!fetch);
          dispatch(setAlert(false));
          showSuccessToast("Item successfully removed");
        }
      }
      if (action === "Replace") {
        const payload = spotlight.map((item) =>
          item.slotNumber === content.slotNumber
            ? { contentId: selected.contentId, slotNumber: content.slotNumber }
            : { contentId: item.contentId, slotNumber: item.slotNumber }
        );

        const response = await axios.put(
          `${BASE_URL}/spotlights/update`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,

              "Content-Type": "application/json",
            },
          }
        );
        if (response?.status === 200) {
          navigate("/admin");
          dispatch(setPage("In the spotlight"));
          dispatch(setAlert(false));
          showSuccessToast("Item successfully replaced");
          dispatch(setReset(false));
        }
      }
    } catch (e) {
      showErrorToast("An error occurred please try again");
    }
  };

  return (
    <Dialog
      open={alertMessage}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          border: `10px solid  ${useThemeRender("borderColorLayer3")}`,
          background: useThemeRender("cardBackgroundColorLayer1"),
          boxShadow: "0px 2px 24px 8px rgba(0, 92, 188, 0.12)",
          padding: "40px",
          width: "500px",
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            lineHeight: "20px",
            color: useThemeRender("textColorLayer2"),
          }}
        >
          {action} item ?
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            lineHeight: "23.8px",
            color: useThemeRender("textColorLayer2"),
          }}
        >
          Are you sure you want to {action.toLowerCase()} the item ?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          variant="outlined"
          sx={{
            textTransform: "none",
            font: "bold",
            fontWeight: 700,
            borderRadius: "24px",
            "&:hover": {
              background: "#004B9A",
            },
            marginRight: "10px",
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleRemove}
          variant="contained"
          sx={{
            font: "bold",
            fontWeight: 700,
            textTransform: "none",
            borderRadius: "24px",
            background: "#D50000",
            "&:hover": {
              background: "#9C0000",
            },
          }}
        >
          {action}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
AlertBox.propTypes = {
  deleteSlotId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFetch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  action: PropTypes.oneOf(["Remove", "Replace"]).isRequired,
  selected: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  content: PropTypes.shape({
    slotNumber: PropTypes.number,
  }),
};
